module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./birthdayLiveView.js"));
	}, "ShareAppView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ShareAppView!./src/pages/Share/birthdayLive/birthdayLiveView.js
// module id = 1103
// module chunks = 431